/* eslint-disable */

import Vue, { PluginObject } from 'vue';
import axios, { AxiosInstance } from 'axios';

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

const config = {
  baseURL: 'https://endpoints.dichvuforex.com/',
  timeout: 60 * 1000, // Timeout
};

export const _axios = axios.create(config);

_axios.interceptors.request.use(
  config =>
    // Do something before request is sent
    config,
  error =>
    // Do something with request error
    Promise.reject(error)
  ,
);

// Add a response interceptor
_axios.interceptors.response.use(
  response =>
    // Do something with response data
    response,
  error =>
    // Do something with response error
    Promise.reject(error)
  ,
);

const plugin:PluginObject<any> = {
  install(_Vue: typeof Vue, options: any) {
    Object.defineProperties(_Vue.prototype, {
      axios: {
        get() {
          return _axios;
        },
      },
      $axios: {
        get() {
          return _axios;
        },
      },
    });
  }
}


Vue.use(plugin);

export default Plugin;
